var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptopMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5,9h-3c-1.93,0-3.5,1.57-3.5,3.5v11.5h10V12.5c0-1.93-1.57-3.5-3.5-3.5Zm.5,12h-4V12.5c0-.28,.22-.5,.5-.5h3c.28,0,.5,.22,.5,.5v8.5Zm-11.77-7h2.77v4H3c-1.66,0-3-1.34-3-3v-2H2V0H22V7h-3V3H5V13h3.31l.92,1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopMobile);
export default __webpack_public_path__ + "static/media/laptop-mobile.c4403f17ddb511d55caad5dacdc4fc6a.svg";
export { ForwardRef as ReactComponent };